export const downloadFile = async (href, filename) => {
  const a = document.createElement('a');
  a.href = href;
  a.download = filename;
  a.click();
};

export const downloadBlob = async (blob, filename) => {
  const href = URL.createObjectURL(blob);

  try {
    await downloadFile(href, filename);
  } finally {
    URL.revokeObjectURL(href);
  }
};
